<app-three-column-template
  [hasMinWidth]="true"
  [hasCustomMain]="true"
  [pageData]="pageData()"
  [showTags]="false">

  <app-side-navigation
    [pageData]="pageData()" slot="left-section"></app-side-navigation>

  <app-ck-viewer [fullBody]="true"
                 [htmlDescription]="pageData()?.summary || pageData()?.htmlDescription"></app-ck-viewer>

  <div class="map">
    <div class="map-image">
      <img alt="world map" src="assets/images/world-map.svg">
      @if (worldParts.length) {
        @for (wp of worldParts; track wp.name) {
          @if (wp.sourceUrl) {
            <div [class.part-active]="wp.active"
                 [class]="'part part-'+wp.name">
              <a [href]="wp.sourceUrl | addFr">{{ wp.title|translate }}</a>

            </div>
          }
        }
      }
    </div>
  </div>

  @if (itemsList.length) {
    <div class="list">
      @for (countriesArr of itemsList; track countriesArr; let last = $last) {
        <div class="list-column" [class.last]="last">
          @for (country of countriesArr; track country.id) {
            <div class="list-item"><a [href]="country.sourceUrl | addFr">{{ country.title }}</a></div>
          }
        </div>
      }
    </div>
  }

  <ng-container slot="right-section">
    <app-links-section
      [isQuickLinks]="true"
      [links]="pageData()?.quickUrls"
      [title]="'Quick links'"></app-links-section>

    <app-default-portlets [pageData]="pageData()"></app-default-portlets>


  </ng-container>
</app-three-column-template>
